/* Lost & Found 2.0 section-cart-drawer.js (P): <lf-cart-drawer> (P61, P62, P64; fixes B1, B4, B5).
   Registers with LF.cart, opens as a real dialog through LF.dialog (focus to Close, trapped, restored; html and body
   locked), refreshes from bundled section rendering, and changes quantities with LF.cart.change.
   The drawer stylesheet (data-css) loads when the browser is idle, off the first render; open() waits for it and
   falls back to the cart page if it cannot load. On the cart page itself LF.cart.open declines (global.js), so the
   header Cart links load a fresh cart page instead of opening the drawer over the page's updates[] form. */
(() => {
'use strict';
const d = document, root = d.documentElement;
const define = (n, c) => { if (!customElements.get(n)) customElements.define(n, c); };
const lf = () => window.LF || null;
const rootUrl = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const idle = (f) => (window.requestIdleCallback ? requestIdleCallback(f, { timeout: 3000 }) : setTimeout(f, 1200));
const pathOf = (u) => { try { return new URL(u, location.href).pathname; } catch (e) { return String(u || ''); } };

define('lf-cart-drawer', class extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.panel = this.querySelector('#lwCartDrawer');
    this.overlay = this.querySelector('#lwCartOverlay');
    if (!this.panel || !this.overlay) return;
    this.bound = true;
    try { this.strings = JSON.parse((this.querySelector('[data-drawer-strings]') || {}).textContent || '{}'); } catch (e) { this.strings = {}; }
    this.onUpdated = (e) => this.updated((e && e.detail) || {});
    this.onLegacy = () => { this.refresh().then(() => this.open({ fresh: true })); };
    this.onDialogClose = (e) => { if (e.detail && e.detail.el === this.panel) this.sync(false); };
    this.onClick = (e) => this.click(e);
    this.onKey = (e) => { if (e.key === 'Escape' && this.isOpen()) { e.preventDefault(); e.stopPropagation(); this.close(); } };
    d.addEventListener('lf:cart:updated', this.onUpdated);
    d.addEventListener('cart:updated', this.onLegacy);
    d.addEventListener('lf:dialog:close', this.onDialogClose);
    this.addEventListener('click', this.onClick);
    this.panel.addEventListener('keydown', this.onKey);
    const L = lf();
    if (L && L.cart) L.cart.registerDrawer(this);
    idle(() => this.css());
  }
  /* Resolves true once the drawer stylesheet has loaded (reusing a <link> the page already has), false on error. */
  css() {
    if (this.cssP) return this.cssP;
    const href = this.dataset.css;
    if (!href) { this.cssP = Promise.resolve(true); return this.cssP; }
    let link = Array.from(d.querySelectorAll('link[rel="stylesheet"]')).find((l) => pathOf(l.href) === pathOf(href));
    this.cssP = new Promise((res) => {
      if (link && link.sheet) { res(true); return; }
      if (!link) { link = d.createElement('link'); link.rel = 'stylesheet'; link.href = href; d.head.appendChild(link); }
      link.addEventListener('load', () => res(true), { once: true });
      link.addEventListener('error', () => res(false), { once: true });
      setTimeout(() => res(!!link.sheet), 8000);
    }).then((ok) => { this.cssOk = ok; if (!ok) this.cssP = null; return ok; });
    return this.cssP;
  }
  disconnectedCallback() {
    d.removeEventListener('lf:cart:updated', this.onUpdated);
    d.removeEventListener('cart:updated', this.onLegacy);
    d.removeEventListener('lf:dialog:close', this.onDialogClose);
    const L = lf();
    if (this.isOpen()) L.dialog.close(this.panel, { returnFocus: false });
    this.bound = false;
  }
  isOpen() { const L = lf(); return !!(this.panel && L && L.dialog && L.dialog.isOpen(this.panel)); }
  open(o) {
    o = o || {};
    const L = lf();
    if (!L || !L.dialog) { location.href = rootUrl() + 'cart'; return; }
    if (this.isOpen()) { if (!o.fresh) this.refresh(); return; }
    if (!this.cssOk) {
      if (!o.trigger) o.trigger = d.activeElement;
      const first = !this.queued;
      this.queued = o;
      if (first) this.css().then((ok) => { const q = this.queued; this.queued = null; if (ok) this.open(q); else location.href = rootUrl() + 'cart'; });
      return;
    }
    clearTimeout(this.ct);
    this.closing = false;
    this.overlay.hidden = false;
    L.dialog.open(this.panel, { trigger: o.trigger || d.activeElement, initialFocus: this.querySelector('#lwCartClose') });
    this.overlay.inert = false;
    this.sync(true);
    const body = this.querySelector('#lwCartBody');
    if (body) body.scrollTop = 0;
    if (!o.fresh) this.refresh();
  }
  close() {
    const L = lf();
    if (!this.isOpen() || this.closing) return;
    const done = () => { clearTimeout(this.ct); this.closing = false; if (this.isOpen()) L.dialog.close(this.panel); else this.sync(false); };
    if (!L.motion) { done(); return; }
    this.closing = true;
    this.panel.classList.add('is-closing');
    this.overlay.classList.add('is-closing');
    this.ct = setTimeout(done, 240);
  }
  sync(on) {
    this.panel.classList.toggle('lw-active', on);
    this.overlay.classList.toggle('lw-active', on);
    this.panel.classList.remove('is-closing');
    this.overlay.classList.remove('is-closing');
    if (on) this.panel.setAttribute('open', '');
    else { this.panel.removeAttribute('open'); this.overlay.hidden = true; this.closing = false; }
    root.classList.toggle('lf-drawer-open', on);
  }
  click(e) {
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); this.close(); return; }
    const b = e.target.closest('[data-action]');
    if (!b || !this.contains(b)) return;
    e.preventDefault();
    if (this.busy) return;
    if (b.getAttribute('aria-disabled') === 'true') { this.limit(b.dataset.cap); return; }
    this.change(b);
  }
  limit(n) {
    const L = lf(), msg = String(this.strings.only || '').replace('[n]', n || '1');
    if (L && L.toast && msg) L.toast(msg, { tone: 'info' });
  }
  change(b) {
    const L = lf();
    if (!L || !L.cart) return;
    const key = b.dataset.key, qty = Math.max(0, Number(b.dataset.qty) || 0), line = b.closest('[data-line]');
    this.busy = true;
    this.focusKey = b.dataset.focusKey || '';
    if (line) { line.classList.add('is-busy'); line.setAttribute('aria-busy', 'true'); }
    L.cart.change({ id: key, quantity: qty })
      .then((detail) => {
        const item = ((detail && detail.cart && detail.cart.items) || []).find((i) => i.key === key);
        if (item && qty > item.quantity) this.limit(item.quantity);
      })
      .catch((err) => {
        if (err && err.status === 422 && b.dataset.action === 'plus') this.limit(b.dataset.cap || (Number(b.dataset.qty) - 1));
        this.refresh();
      })
      .finally(() => {
        this.busy = false;
        if (line && line.isConnected) { line.classList.remove('is-busy'); line.removeAttribute('aria-busy'); }
      });
  }
  updated(detail) {
    const html = detail.sections && detail.sections['cart-drawer'];
    const applied = html ? this.apply(html) : false;
    if (!applied) this.refresh();
    if (detail.openDrawer) this.open({ fresh: true, trigger: d.activeElement });
    else if (detail.source === 'change' && this.isOpen()) this.announceState();
  }
  refresh() {
    return fetch(rootUrl() + '?sections=cart-drawer', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status))))
      .then((data) => {
        if (!this.apply(data && data['cart-drawer'])) throw new Error('No drawer section');
        const L = lf();
        if (L && L.cart) L.cart.setCount(Number(this.dataset.itemCount) || 0);
      })
      .catch(() => this.stale());
  }
  apply(html) {
    if (typeof html !== 'string') return false;
    const src = new DOMParser().parseFromString(html, 'text/html').querySelector('lf-cart-drawer');
    if (!src) return false;
    const a = d.activeElement, hadFocus = !!(a && this.panel.contains(a));
    const key = (hadFocus && a.dataset && a.dataset.focusKey) || this.focusKey || '';
    this.dataset.itemCount = src.dataset.itemCount || '0';
    ['title', 'body', 'foot'].forEach((k) => {
      const to = this.querySelector('[data-swap="' + k + '"]'), from = src.querySelector('[data-swap="' + k + '"]');
      if (!to || !from) return;
      to.replaceChildren(...Array.from(from.childNodes));
      to.hidden = from.hidden;
    });
    this.focusKey = '';
    if (hadFocus && !this.panel.contains(d.activeElement)) this.restore(key);
    return true;
  }
  restore(key) {
    let el = null;
    if (key) el = Array.from(this.panel.querySelectorAll('[data-focus-key]')).find((x) => x.dataset.focusKey === key) || null;
    /* The next line's title link (the image link is tabindex -1 and aria-hidden), else a control, else any focusable
       link in the body (the empty state), else Close. */
    if (!el) el = this.panel.querySelector('#lwCartBody .lf-cart-line__title a, #lwCartBody [data-action], #lwCartBody a[href]:not([tabindex="-1"])') || this.querySelector('#lwCartClose');
    if (el) el.focus();
  }
  stale() {
    const box = this.querySelector('[data-drawer-checkout]'), tpl = this.querySelector('template[data-drawer-review]');
    if (box && tpl) box.replaceChildren(tpl.content.cloneNode(true));
  }
  announceState() {
    const L = lf(), t = this.querySelector('#lwCartCount'), empty = this.querySelector('.lf-cart-empty__title');
    if (L && L.announce) L.announce([t && t.textContent.trim(), empty && empty.textContent.trim()].filter(Boolean).join('. '));
  }
});
})();
